import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import Swal from 'sweetalert2';
import {
  ComunidadControllerService,
  DiccionarioControllerService,
  DiccionarioElementoDTO,
  PageDTOPoseedorDTO,
  PoseedorControllerService,
  PoseedorDTO,
  PoseedorEstadoControllerService,
  PoseedorFilterDTO,
} from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { HoldersService } from '../../../services/holders.service';
import { HoldersStatusChangeDialogComponent } from '../holders-status-change-dialog/holders-status-change-dialog.component';
import { HoldersBajaMotivoDialogComponent } from '../holders-baja-motivo-dialog/holders-baja-motivo-dialog.component';
import { forkJoin } from 'rxjs';
import { zip } from 'rxjs';

const ESTADO_COMPLETADO_ID = 4;

@Component({
  selector: 'app-holders-search',
  templateUrl: './holders-search.component.html',
  styleUrls: ['./holders-search.component.scss'],
})
export class HoldersSearchComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  updateList: boolean = false;
  cnaeEndpoint = this.environment.urlBackCore + 'api/v1/core/cnae';

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;

  comunidadArray: any[] = [];
  estadoArray: any[] = [];

  headArray: any = [
    {
      Head: 'ID Pos.',
      FieldName: 'id',
      tooltipHeader: 'ID. Poseedor',
    },
    {
      Head: 'Razón Social',
      FieldName: 'razonSocial',
      tooltipHeader: 'Razón Social del poseedor',
    },
    {
      Head: 'Documento',
      FieldName: 'codigoDocumento',
      tooltipHeader: 'Documento del poseedor (NIE,NIF)',
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcionCorta',
      tooltipHeader: 'Estado del poseedor',
    },
    {
      Head: 'Centro',
      FieldName: 'denominacionCentro',
      tooltipHeader: 'Denominación del centro',
    },
        {
      Head: 'NIMA',
      FieldName: 'nima',
      tooltipHeader: 'NIMA del poseedor',
    },
        {
      Head: 'CC. AA. Dir. Fis.',
      FieldName: 'comunidadFisica',
      Attribute: 'nombre',
      tooltipHeader: 'Comunidad autónoma (Dirección Física)',
    },
        {
      Head: '% Adh.',
      FieldName: 'porcentajeAdheridos',
      tooltipHeader: '% Adheridos (Año en Curso)',
    },
    {
      Head: 'Tip. Regis.',
      FieldName: 'contratoGestor',
      renderValue: (item: any) => (item?.contratoGestor == true ? 'Poseedor Final' : 'Usuario SDDR Abierto'),
      tooltipHeader: 'Tipo de Registro',
    },
    {
      Head: 'Acuerdo Gest. Env.',
      FieldName: 'acuerdoGestorEnvalora',
      renderValue: (item: any) => (item?.acuerdoGestorEnvalora == true ? 'Si' : 'No'),
      tooltipHeader: 'Acuerdo gestor Envalora',
    },
    {
      Head: 'Acc.',
      FieldName: 'actions',
      tooltipHeader: 'Acciones',
      check: false,
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Editar',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'generar_acuerdo',
              name: 'Generar acuerdo',
              show: {
                params: 'canAccessUpdateCont',
                accion: 'generar_acuerdo',
              },
            },
            {
              nameButton: 'completado',
              name: 'Completado',
              show: {
                params: 'canAccessCompletarRevision',
                accion: 'completado',
              },
            },
            {
              nameButton: 'baja_poseedor',
              name: 'Baja de Poseedor',
              show: {
                params: 'canAccessUpdateUnregist',
                accion: 'baja_poseedor',
              },
            },
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];
  gridArray: Array<PoseedorDTO> = [];

  estadosArray: any = [];

  searchForm: FormGroup;
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private poseedorControllerService: PoseedorControllerService,
    private comunidadControllerService: ComunidadControllerService,
    private poseedorEstadoControllerService: PoseedorEstadoControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private holdersService: HoldersService,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.searchForm = this.formBuilder.group({
      idPoseedor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      comunidad_autonoma: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      nima: [{ value: null, disabled: false }],
      cnae: [{ value: null, disabled: false }],
      contratoGestor: [{ value: null, disabled: false }],
      acuerdoGestorEnvalora: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });

    if (this.canAccessChangeStatus()) {
      this.headArray.filter((item: any) => item.FieldName == 'actions')[0].check = true;
    }
  }

  ngOnInit() {
    console.log('[HoldersSearch ngOnInit] Iniciando carga de datos');
    
    // Cargamos ambos combos y esperamos a que terminen
    forkJoin({
      estados: this.poseedorEstadoControllerService.findAll6(),
      comunidades: this.comunidadControllerService.listarComunidades3({}, { page: 0, size: 500, sort: [] })
    }).subscribe({
      next: (res: any) => {
        this.estadosArray = res.estados;
        this.comunidadArray = res.comunidades.datos;
        console.log('[HoldersSearch ngOnInit] Combos cargados con éxito');

        // Una vez cargados los combos, comprobamos si hay búsqueda guardada
        const storedForm = sessionStorage.getItem('holdersSearchForm');
        if (storedForm) {
          try {
            const formData = JSON.parse(storedForm);
            console.log('[HoldersSearch ngOnInit] Restaurando formulario:', formData);
            
            this.searchForm.patchValue(formData);
            
            // Forzamos la búsqueda si había criterios
            this.searchData();
            
            // Limpiamos la sesión una vez restaurado
            sessionStorage.removeItem('holdersSearchForm');
          } catch (e) {
            console.error('[HoldersSearch ngOnInit] Error al restaurar formulario:', e);
          }
        }
      },
      error: (err) => {
        console.error('[HoldersSearch ngOnInit] Error cargando combos:', err);
      }
    });
    this.comboEstados();
    this.getComboComunidad();
    this.cargarCombos();
  }


  checked(event: any) { }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.poseedorControllerService
      .exportCSV2(backendFilter, 'response')
      .subscribe((res) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'Exportacion_poseedor.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
    // Limpiar sessionStorage cuando se limpia el formulario
    sessionStorage.removeItem('holdersSearchForm');
    console.log('[HoldersSearch clearSearcher] sessionStorage limpiado');
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => {
          if (v?.id !== undefined && filtro.value?.id !== undefined) return v.id !== filtro.value.id;
          if (v?.clase !== undefined && filtro.value?.clase !== undefined) return v.clase !== filtro.value.clase;
          return v !== filtro.value;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.searchForm.get('idPoseedor')?.value;
    if (id) filtros.push({ label: ` ${id}`, campo: 'idPoseedor' });

    const doc = this.searchForm.get('codigo_documento')?.value;
    if (doc?.trim()) filtros.push({ label: doc.trim(), campo: 'codigo_documento' });

    const razon = this.searchForm.get('razon_social')?.value;
    if (razon?.trim()) filtros.push({ label: razon.trim(), campo: 'razon_social' });

    const nima = this.searchForm.get('nima')?.value;
    if (nima) filtros.push({ label: ` ${nima}`, campo: 'nima' });

    const comunidad = this.searchForm.get('comunidad_autonoma')?.value;
    if (comunidad) filtros.push({ label: comunidad.nombre, campo: 'comunidad_autonoma' });

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((est: any) => {
        filtros.push({ label: est.descripcion ?? est.descripcionCorta ?? String(est), campo: 'estado', value: est });
      });
    }

    const cnaes = this.searchForm.get('cnae')?.value as any[];
    if (cnaes?.length) {
      cnaes.forEach((c: any) => {
        const label = c.clase ? `${c.clase} - ${c.descripcion ?? ''}` : String(c);
        filtros.push({ label: label.length > 35 ? label.slice(0, 33) + '…' : label, campo: 'cnae', value: c });
      });
    }

    const contratoGestor = this.searchForm.get('contratoGestor')?.value;
    if (contratoGestor !== null && contratoGestor !== undefined) {
      filtros.push({ label: contratoGestor ? 'Poseedor Final' : 'Usuario SDDR Abierto', campo: 'contratoGestor' });
    }

    const acuerdo = this.searchForm.get('acuerdoGestorEnvalora')?.value;
    if (acuerdo !== null && acuerdo !== undefined) {
      filtros.push({ label: ` ${acuerdo ? 'Sí' : 'No'}`, campo: 'acuerdoGestorEnvalora' });
    }
const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'cnae': {
        return this.searchForm.get('cnae') as FormControl;
        break;
      }
      default: {
        return this.searchForm.get('') as FormControl;
        break;
      }
    }
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  private getBackendFilter() {
    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    const backendFilter: PoseedorFilterDTO = {
      id: this.searchForm.get('idPoseedor')?.value,
      codigoDocumento: this.searchForm.get('codigo_documento')?.value,
      razonSocial: this.searchForm.get('razon_social')?.value ? this.searchForm.get('razon_social')?.value.trim() : undefined,
      cnae1: this.searchForm.get('cnae')?.value,
      nima: this.searchForm.get('nima')?.value,
      comunidadAutonoma: this.searchForm.get('comunidad_autonoma')?.value?.id,
      estado: { id: selectEstadosId },
      contratoGestor: this.searchForm.get('contratoGestor')?.value,
      acuerdoGestorEnvalora: this.searchForm.get('acuerdoGestorEnvalora')?.value,

    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  searchData(initPage:boolean = false) {
    if(initPage){
      this.pageNumber = 0;
    }
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.poseedorControllerService
      .findAll5(
        backendFilter,
        {
          page: page,
          size: size,
          sort: ['id,desc'],
        },
        orden,
        tipoOrden
      )
      .subscribe({
        next: (data: PageDTOPoseedorDTO) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos);
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openDetailShow(element.id);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'generar_acuerdo') {
      if (element.contratoGestor && element.residuosEnvase?.length > 0) {
        const currentYear = (new Date()).getFullYear();
        const isWasteForecastExist = element.residuosEnvase.some((e: any) => {
          if (currentYear === 2024 && e.anioDatos === currentYear + 1) {//TODO: Condición provisional para el año 2024, ya que solo se pueden crear previsiones de residuos a partir del 2025
            return true;
          } else if (e.anioDatos === currentYear) {
            return true;
          } else {
            return false;
          }
        });
        if (isWasteForecastExist) {
          this.spinnerSrv.loadingShow();
          this.poseedorControllerService.generarAcuerdo(element.id).subscribe({
            next: () => {
              this.spinnerSrv.loadingHide();
              this.searchData();
              this.snackBarSrv.showSnackBar(
                'Se ha generado el acuerdo correctamente. El usuario recibirá un correo electrónico con instrucciones para la firma del acuerdo.',
                'success'
              );
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              console.log(err);
            },
          });
        } else {
          this.snackBarSrv.showSnackBar(
            'No puede generar el acuerdo si no tiene un contrato previamente firmado con un gestor y una Previsión de residuos cumplimentada',
            'error'
          );
        }
      } else {
        this.snackBarSrv.showSnackBar(
          'No puede generar el acuerdo si no tiene un contrato previamente firmado con un gestor y una Previsión de residuos cumplimentada',
          'error'
        );
      }
    } else if (element.nameButton == 'completado') {
      this.spinnerSrv.loadingShow();
      this.poseedorControllerService.multipleActualizarEstado(ESTADO_COMPLETADO_ID, [element.id]).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.searchData();
          this.snackBarSrv.showSnackBar(
            'Se ha completado el poseedor correctamente',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          console.log(err);
        },
      })
    } else if (element.nameButton == 'baja_poseedor') {
      this.abrirDialogoMotivoBaja(element);
    }
  }

  private abrirDialogoMotivoBaja(element: any): void {
    const dialogRef = this.dialog.open(HoldersBajaMotivoDialogComponent, {
      width: '600px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        poseedores: [element],
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.darBajaPoseedor(element);
      }
    });
  }

  private darBajaPoseedor(element: any): void {
    this.spinnerSrv.loadingShow();
    this.poseedorControllerService.bajaPoseedor(element.id).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.searchData();
        this.snackBarSrv.showSnackBar(
          'Se ha dado de baja el poseedor correctamente',
          'success'
        );
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        console.log(err);
      },
    });
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar el poseedor?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarPoseedor(element);
      }
    });
  }

  eliminarPoseedor(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.poseedorControllerService.borrarPoseedor(element.id).subscribe({
        next: (value: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `El poseedor se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar el poseedor',
            'error'
          );
        },
      });
    }
  }

  comboEstados() {
    this.poseedorEstadoControllerService.findAll6().subscribe({
      next: (data: any) => {
        this.estadosArray = data!;
        console.log('[HoldersSearch comboEstados] Combos de estado cargados:', data);
      },
      error: () => {
        console.log('[HoldersSearch comboEstados] Error al cargar combos de estado');
      },
    });
  }

  openDetailShow(id: number): void {
    // Guardar formulario en sessionStorage antes de navegar
    const formValue = this.searchForm.getRawValue();
    sessionStorage.setItem('holdersSearchForm', JSON.stringify(formValue));
    console.log('[HoldersSearch openDetailShow] Formulario guardado en sessionStorage:', formValue);
    this.holdersService.setTempHoldersSearch(true);
    this.router.navigate(['/holders/detail', id], {
      state: { searchForm: formValue }
    });
  }

  getCnaDescription(cnae: any) {
    return cnae.clase + ' - ' + cnae.descripcion;
  }

  getCnaeObjectQuery(searchterm: string) {
    return {
      descripcion: `or(ci(${searchterm}))`,
      clase: `or(ci(${searchterm}))`,
    };
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('poseedores', 'view');
    const resultDelete = this.authService.can('poseedores', 'delete');
    const resultUpdateCont = this.authService.can(
      'poseedores',
      'update-contract'
    );
    const resultUpdateUnregist = this.authService.can(
      'poseedores',
      'update-unregister'
    );
    const esGestorEnvalora = this.canViewRol('PO-ENV-GEST');

    const listPermission = list.map((objeto: any) => {
      const estadoDelete =
        objeto.estado && [1, 2, 3, 6].includes(objeto.estado.id);
      const estadoUpdateCont =
        objeto.estado && (objeto.estado.id === 2 || objeto.estado.id === 6);
      const estadoCompletarRevision = objeto.estado && objeto.estado.id === 7;
      const estadoUpdateUnregist = objeto.estado && objeto.estado.id === 4;

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete: resultDelete && estadoDelete,
        canAccessUpdateCont: resultUpdateCont && estadoUpdateCont,
        canAccessCompletarRevision: esGestorEnvalora && estadoCompletarRevision,
        canAccessUpdateUnregist: resultUpdateUnregist && estadoUpdateUnregist,
      };
    });

    return listPermission;
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  compareComunidad = (c1: any, c2: any): boolean => {
    if (!c1 || !c2) return c1 === c2;
    return c1.id === c2.id;
  }

  compareEstado = (e1: any, e2: any): boolean => {
    if (!e1 || !e2) return e1 === e2;
    return e1.id === e2.id;
  }

  getComboComunidad() {
    this.comunidadControllerService
      .listarComunidades3({}, { page: 0, size: 500, sort: [] })
      .subscribe({
        next: (data: any) => {
          this.comunidadArray = data.datos!;
          console.log('[HoldersSearch getComboComunidad] Comunidades cargadas:', data.datos);
        },
        error: () => {
          console.log('[HoldersSearch getComboComunidad] Error al cargar comunidades');
        },
      });
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessChangeStatus(): boolean {
    return this.canViewRol('AD-ENV-GEST');
  }

  comprobarCambioEstado() {
    const list = this.gridArray
      .filter((x: any) => x.checked === true)
      .map((x: any) => x.id);

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        'Debe seleccionar al menos un poseedor para realizar el cambio de estado.',
        'error'
      );
      return;
    }

    const selectedPoseedores = this.gridArray.filter((p: any) =>
      list.includes(p.id)
    );
    const estadoActual = (selectedPoseedores[0] as any).estado?.id;
    if (
      !selectedPoseedores.every(
        (item: any) => item.estado?.id == estadoActual
      )
    ) {
      this.snackBarSrv.showSnackBar(
        'Todos los poseedores seleccionados deben tener el mismo estado.',
        'error'
      );
      return;
    }

    const dialogRef = this.dialog.open(HoldersStatusChangeDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        poseedores: selectedPoseedores,
        estadoActual: estadoActual,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData(true);
      }
    });
  }
  cargarCombos() {
    zip(
          this.diccionarioControllerService.listarElementos(['ORDEN_POSEEDORES_BUSQUEDA'])
        ).subscribe({
          next: (responses: any[]) => {

            this.orden = responses[0]['ORDEN_POSEEDORES_BUSQUEDA'];
          },
          error: (err) => {
            console.log(err);
          },
        });
  }
      canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    }
    
}
